import { useEffect } from 'react';
import type { FC } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { Button, Box, Drawer, Hidden } from '@mui/material';
import { Logo } from './Logo';
import { accountService, UserRole } from '../account.service';

interface MainSidebarProps {
    onMobileClose: () => void;
    openMobile: boolean;
}

export const MainSidebar: FC<MainSidebarProps> = ({ onMobileClose, openMobile }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const account = accountService.getAccount();

    useEffect(() => {
        if (openMobile && onMobileClose) {
            onMobileClose();
        }
        //READ: https://stackoverflow.com/questions/55840294/how-to-fix-missing-dependency-warning-when-using-useeffect-react-hook
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    const onSignIn = () => {
        if (account) {
            accountService.logout();
            navigate('/');
        } else {
            navigate('/account/login');
        }
    };

    const onProfile = () => {
        if (account) {
            switch (account.role) {
                case UserRole.Reseller:
                    navigate('/reseller/orders');
                    break;
                case UserRole.Admin:
                    navigate('/kb/');
                    break;
                default:
                    navigate('/client/orders');
                    break;
            }
        } else {
            window.open('https://lsoft.zendesk.com/hc/en-us/requests/new', '_blank');
        }
    };

    return (
        <Hidden mdUp>
            <Drawer
                anchor="left"
                onClose={onMobileClose}
                open={openMobile}
                variant="temporary"
                PaperProps={{
                    sx: {
                        backgroundColor: 'background.default',
                        width: 256,
                    },
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        p: 2,
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            p: 2,
                        }}
                    >
                        <RouterLink to="/">
                            <Logo />
                        </RouterLink>
                    </Box>

                    <Button
                        sx={{
                            justifyContent: 'flex-start',
                            pl: `16px`,
                            pr: '8px',
                            py: '12px',
                            width: '100%',
                        }}
                        variant="text"
                        onClick={onProfile}
                    >
                        {account ? (account.role === UserRole.Admin ? 'Dashboard' : 'Profile') : 'Submit request'}
                    </Button>

                    <Button
                        variant="text"
                        sx={{
                            justifyContent: 'flex-start',
                            pl: `16px`,
                            pr: '8px',
                            py: '12px',
                            width: '100%',
                        }}
                        onClick={onSignIn}
                    >
                        {account ? 'Sign Out' : 'Sign In'}
                    </Button>
                </Box>
            </Drawer>
        </Hidden>
    );
};
